module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am181-ed82a935e21a8ad52dc53ebd89adba41.jpg";